import { isAfter } from 'date-fns';

/**
 * Transform API accommodation booking parts into a download voucher for rooms.
 */
export function transformTicketAccommodation(
    accommodation: ApiSchema['Accommodation'],
    apiBooking: ApiSchema['Booking'],
): TicketAccommodation {
    const fulfillment = apiBooking.fulfillments?.find(f => f.issuer !== 'TOFT' && f.bookingParts?.some(bp => bp.id === accommodation.id));
    const dateFrom = zurichDay(accommodation.validFrom);
    const dateUntil = zurichDay(accommodation.validUntil);

    const id = accommodation.id;
    const type = 'Accommodation';
    const summaryLine1 = accommodation.accommodationDetails?.name ?? '';
    const summaryLine2 = `${formatDateFromTo(dateFrom, dateUntil)} (${formatFromToDuration(dateFrom, dateUntil, true)})`;
    const detailLine1 = accommodation.summary ?? '';
    const detailLine2 = undefined;

    // The downloadable documents (room vouchers)
    const documents = fulfillment?.fulfillmentDocuments?.map(d => ({
        download: d.downloadLink ?? '',
        format: d.format,
        type: d.type,
    })) ?? [];

    // If already in the past
    const isExpired = isAfter(zurichDate(), zurichDate(accommodation?.validUntil));
    // If already refunded
    const isRefunded = accommodation.status === 'REFUNDED';
    const isDownloadable
        = documents.length > 0
            && !isExpired
            && !isRefunded;

    return {
        id,
        type,
        summaryLine1,
        summaryLine2,
        detailLine1,
        detailLine2,
        documents,
        isExpired,
        isRefunded,
        isDownloadable,
    };
}
